export default class ProjectInstance {
    static instance = null;

    static getInstance() {
        return ProjectInstance.instance;
    }

    static setInstance(project) {
        ProjectInstance.instance = project;
    }
}
